"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2013],{

/***/ 92013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95674);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core_Box__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81762);
/* harmony import */ var _helpers_observability__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77997);
/* harmony import */ var _account_AccountMenu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43029);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35480);
/* harmony import */ var _EiChevronDownIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87098);
/* harmony import */ var _MenuPanel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37197);












var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o0"
})("display:inline-block;width:1em;height:1em;margin-bottom:0.2em;");
var Left = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o1"
})("display:flex;flex:1;");
var MenuButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e6jtd0o2"
})("border:0;height:27px;width:27px;margin-right:15px;cursor:pointer;float:left;background:transparent\n    url('https://images.opendoor.com/source/s3/imgdrop-production/06fcecd57df4411b9f7448f24fbff233.svg?preset=square-2048')\n    center no-repeat;padding:0;");
var Middle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o3"
})("@media (max-width:767px){display:none;}");
var Nav = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o4"
})("padding-left:0;margin-bottom:0;list-style:none;:before,:after{display:table;content:' ';}:after{clear:both;}");
var NavUL = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("ul", {
    target: "e6jtd0o5"
})("display:inline-block;margin:0;list-style:none;padding:0;");
var NavLI = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("li", {
    target: "e6jtd0o6"
})("display:inline-block;margin:0 10px;");
var activeNavLinkStyle = function(props) {
    if (props.active) {
        return "color: ".concat(_opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].brand50 */ .ZP.brand50, ";");
    }
    return "";
};
var NavLIA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e6jtd0o7"
})("color:#525975;", activeNavLinkStyle, ";");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("header", {
    target: "e6jtd0o8"
})("background:#ffffff;position:fixed;top:0;left:0;z-index:3;width:100%;box-shadow:0px 3px 40px rgba(68,89,109,0.1);");
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o9"
})("display:flex;padding:15px;justify-content:space-between;");
var Right = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e6jtd0o10"
})("flex:1;text-align:right;");
var NavLink = function(props) {
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_3__/* .useObservability */ .C3)().trackEvent;
    var onClickFn = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", props.elementName, undefined, {
            categoryOverride: "homepage"
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLIA, {
        onClick: onClickFn,
        href: props.href,
        active: props.active,
        "aria-current": props.active,
        children: props.children
    });
};
var SkipLinkContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("button", {
    target: "e6jtd0o11"
})({
    alignItems: "center",
    backgroundColor: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].neutrals0 */ .ZP.neutrals0,
    border: 0,
    bottom: 0,
    color: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_8__/* ["default"].brand50 */ .ZP.brand50,
    display: "flex",
    justifyContent: "center",
    left: 0,
    outline: 0,
    position: "absolute",
    top: 0,
    transform: "translateX(-100%)",
    width: "100%",
    zIndex: 1,
    "&:focus": {
        textDecoration: "underline",
        transform: "translateX(0)"
    }
});
var SkipLink = function(_props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SkipLinkContainer, {
        onClick: function() {
            // there should only be 1 main on any page and it should wrap the main content
            var mainElem = document.querySelector("main");
            mainElem && mainElem.focus();
        },
        children: "Skip to main content"
    });
};
var redirectToLogin = function() {
    document.location.href = "".concat(_globals__WEBPACK_IMPORTED_MODULE_5__/* .COSMOS_URL */ .EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
};
var Header = function(props) {
    var _activeNav = props.activeNav, activeNav = _activeNav === void 0 ? "sell" : _activeNav, extraNavLinks = props.extraNavLinks, hideHeaderNavLinks = props.hideHeaderNavLinks, _isMenuOpen = props.isMenuOpen, isMenuOpen = _isMenuOpen === void 0 ? false : _isMenuOpen, _navMenuButtonId = props.navMenuButtonId, navMenuButtonId = _navMenuButtonId === void 0 ? _MenuPanel__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_NAV_MENU_BUTTON_ID */ .Q7 : _navMenuButtonId, _navMenuId = props.navMenuId, navMenuId = _navMenuId === void 0 ? _MenuPanel__WEBPACK_IMPORTED_MODULE_7__/* .DEFAULT_NAV_MENU_ID */ .KB : _navMenuId, _toggleMenuOpen = props.toggleMenuOpen, toggleMenuOpen = _toggleMenuOpen === void 0 ? function() {} : _toggleMenuOpen;
    var trackEvent = (0,_helpers_observability__WEBPACK_IMPORTED_MODULE_3__/* .useObservability */ .C3)().trackEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isExpanded = ref[0], setExpanded = ref[1];
    var ref1 = (0,_opendoor_auth_fe__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)(), human = ref1.user, authentication = ref1.authentication;
    var isLoggedIn = authentication.state === "authenticated";
    var handleMenuClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "menu", undefined, {
            categoryOverride: "homepage"
        });
        toggleMenuOpen();
    };
    var handleAccountClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-icon", undefined, {
            categoryOverride: "homepage"
        });
        authentication.state === "authenticated" ? setExpanded(!isExpanded) : redirectToLogin();
    };
    var fullName = human === null || human === void 0 ? void 0 : human.fullName;
    var firstName = fullName ? fullName.split(" ")[0] : "";
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(SkipLink, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Container, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Left, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(MenuButton, {
                                "aria-controls": navMenuId,
                                "aria-expanded": isMenuOpen ? "true" : "false",
                                "aria-haspopup": "true",
                                "aria-label": "Navigation menu",
                                id: navMenuButtonId,
                                onClick: handleMenuClick
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)("img", {
                                src: "https://images.opendoor.com/source/s3/imgdrop-production/2024-09-1726263311004-74235.png?preset=square-2048",
                                alt: "Opendoor",
                                height: 27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Middle, {
                        children: !hideHeaderNavLinks && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Nav, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(NavUL, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                            active: activeNav === "sell",
                                            href: "/",
                                            elementName: "homepage",
                                            children: "Sell"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                            active: activeNav === "buy",
                                            href: "/homes",
                                            elementName: "homes",
                                            children: "Buy"
                                        })
                                    }),
                                    (extraNavLinks || []).map(function(nav) {
                                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLI, {
                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(NavLink, {
                                                href: nav.href,
                                                children: nav.name
                                            })
                                        }, nav.name);
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(Right, {
                        onClick: handleAccountClick,
                        children: isLoggedIn ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_opendoor_bricks_core_Box__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            cursor: "pointer",
                            fontWeight: "semibold",
                            children: [
                                "Welcome ",
                                firstName,
                                " \xa0",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_EiChevronDownIcon__WEBPACK_IMPORTED_MODULE_6__/* .EiChevronDownIcon */ .O, {})
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_account_AccountMenu__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    isExpanded: isExpanded,
                                    isLoggedIn: isLoggedIn
                                })
                            ]
                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            href: "#",
                            fontWeight: "semibold",
                            analyticsName: "cosmos-sign-in",
                            "aria-label": "",
                            children: "Sign In"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 37197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KB": function() { return /* binding */ DEFAULT_NAV_MENU_ID; },
/* harmony export */   "Q7": function() { return /* binding */ DEFAULT_NAV_MENU_BUTTON_ID; },
/* harmony export */   "TJ": function() { return /* binding */ MenuOverlay; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59433);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4796);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99425);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77373);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35480);









var DEFAULT_NAV_MENU_BUTTON_ID = "nav-menu-button";
var DEFAULT_NAV_MENU_ID = "nav-menu";
var activeStyle = function(props) {
    if (!props.active) return "display: none;";
    return "\n  transform: translateX(0);\n  opacity: 1;\n  visibility: visible;\n  display: inline;\n  ";
};
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1k8sh3t0"
})("width:320px;padding:20px 45px;background:#ffffff;position:fixed;top:0;left:0;z-index:12;height:100%;overflow-y:scroll;box-shadow:0 0 30px rgba(0,0,0,0.3);visibility:hidden;opacity:0;transform:translateX(-150px);transition:all ease-in-out 0.3s;", activeStyle, ";");
var MenuPanelCategoryA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e1k8sh3t1"
})("font-size:16px;color:#515778;display:block;padding-bottom:10px;");
var MenuOverlay = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1k8sh3t2"
})("height:100%;width:100%;display:none;opacity:0;background:rgba(255,255,255,0.5);position:fixed;top:0;left:0;z-index:9;transition:all ease-in-out 0.3s;", activeStyle, ";");
var MenuCategory = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontWeight: "semibold",
            fontSize: "s2",
            children: props.title
        })
    });
};
var MenuPanelAppDownload = function(props) {
    var href = props.href;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        "aria-label": "Download the Opendoor app",
        analyticsName: "cosmos-download-app-link",
        fontWeight: "semibold",
        padding: "20px 0 20px 50px",
        lineHeight: "s5",
        background: "transparent url('https://images.opendoor.com/source/s3/imgdrop-production/c06e544a05124f56802db784568b6e64.svg?preset=square-2048') left center no-repeat",
        href: href,
        children: props.children
    });
};
var MenuPanelCategoryLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryA, {
        href: props.href,
        children: props.children
    });
};
var StandaloneLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e1k8sh3t3"
})("display:block;padding:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__/* .space[3] */ .D[3], "px;font-size:16px;font-weight:500;color:#1c2b4d;display:block;cursor:pointer;");
var MenuPanel = function(param) {
    var active = param.active, _navMenuButtonId = param.navMenuButtonId, navMenuButtonId = _navMenuButtonId === void 0 ? DEFAULT_NAV_MENU_BUTTON_ID : _navMenuButtonId, _navMenuId = param.navMenuId, navMenuId = _navMenuId === void 0 ? DEFAULT_NAV_MENU_ID : _navMenuId, toggleMenuOpen = param.toggleMenuOpen;
    var containerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (active && containerRef.current) {
            containerRef.current.focus();
        }
    }, [
        active
    ]);
    var trapFocus = function(e) {
        var ref;
        if (e.key !== "Tab") return;
        var containerElements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var firstElement = containerElements && containerElements[0];
        var lastElement = containerElements && containerElements[containerElements.length - 1];
        // tabbing forwards on the last element (Careers)
        if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            return e.preventDefault();
        }
        // tabbing backwards on the first element (Close button)
        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(Container, {
        id: navMenuId,
        active: active,
        "aria-labelledby": navMenuButtonId,
        onKeyDown: function(e) {
            return e.key === "Escape" && toggleMenuOpen();
        },
        ref: containerRef,
        tabIndex: -1,
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "6",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        tag: "h4",
                        typography: "$subheaderMedium",
                        children: "Menu"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        "aria-label": "Close menu",
                        analyticsName: "cosmos-menu-close-button",
                        variant: "icon",
                        onClick: toggleMenuOpen,
                        onKeyDown: trapFocus,
                        size: "sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            size: 16
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__/* .AccordionList */ .E, {
                variant: "compact",
                analyticsName: "menu-accordion-top",
                listOfAccordions: [
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/",
                                    elementName: "homepage",
                                    children: "Request an offer"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/reviews",
                                    children: "Reviews"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/stories",
                                    children: "Stories"
                                })
                            ]
                        }),
                        panelId: "request-an-offer",
                        startExpanded: true,
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Sell your home"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                href: "/w/homes",
                                children: "Browse homes"
                            })
                        }),
                        panelId: "buy-a-home",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Buy a home"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                href: "/w/builder",
                                children: "Builder trade-up"
                            })
                        }),
                        panelId: "buy-and-sell",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Buy and sell"
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelAppDownload, {
                href: "https://opendoor.app.link/homepage",
                children: "Download App"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__/* .AccordionList */ .E, {
                analyticsName: "menu-accordion-bottom",
                variant: "compact",
                listOfAccordions: [
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/agents#alp-buy--form",
                                    children: "Make an offer"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/agents",
                                    children: "Request an offer"
                                })
                            ]
                        }),
                        panelId: "agents",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Agents"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/vendor-partnerships",
                                    children: "Vendors"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/partner/builder",
                                    children: "Builder"
                                })
                            ]
                        }),
                        panelId: "partners",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Partners"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/about",
                                    children: "Company + Mission"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/faq",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/press"),
                                    children: "Press"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/contact-us",
                                    children: "Contact"
                                })
                            ]
                        }),
                        panelId: "about",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "About"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/blog"),
                                    children: "Blog"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/education"),
                                    children: "Education"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/home-sale-calculator",
                                    children: "Home sale calculator"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/mortgage-calculator",
                                    children: "Mortgage calculator"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/briefs"),
                                    children: "Briefs"
                                })
                            ]
                        }),
                        panelId: "resources",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Resources"
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "/w/faq",
                children: "FAQ"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "https://help.opendoor.com",
                children: "Help Center"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "/jobs",
                onKeyDown: trapFocus,
                children: "Careers"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MenuPanel);


/***/ })

}]);